import { render, staticRenderFns } from "./ResetPasswordInput.vue?vue&type=template&id=2c0b9156&scoped=true&"
import script from "./ResetPasswordInput.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordInput.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordInput.vue?vue&type=style&index=0&id=2c0b9156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b9156",
  null
  
)

export default component.exports